// Packages
import Vue from 'vue';

// Blocks
import BackgroundVideo from '~scripts/blocks/vue/BackgroundVideo.vue';

// Videos
const forumResultsVideos = document.querySelectorAll('.js-forum-results-video');
forumResultsVideos.forEach((video) => {
  new Vue({
    el: video,
    name: 'BackgroundVideo',
    components: {
      BackgroundVideo,
    },
  });
});
